import React from 'react';

const CameraPlaceholder = ({ title }) => {
  return (
    <div className="rounded-lg overflow-hidden shadow-md bg-gradient-to-br from-gray-100 to-gray-200 border border-gray-200 rounded-lg relative h-full flex flex-col min-h-0">
      {/* Contenu principal du placeholder */}
      <div className="flex-1 flex flex-col min-h-0 relative">
        {/* Zone de visualisation avec placeholder */}
        <div className="flex-1 flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 relative">
          <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 p-4">
            <div className="text-gray-400 flex flex-col items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              <span className="mt-2 text-sm text-gray-500">Aucune caméra</span>
              <span className="text-xs text-gray-400 mt-1">En attente</span>
            </div>
          </div>
        </div>

        {/* Barre de contrôle en bas */}
        <div className="absolute bottom-0 left-0 right-0 bg-white py-2 px-3 flex flex-col border-t border-gray-200 flex-shrink-0 min-h-[60px] opacity-100 transition-opacity duration-300 z-20">
          {/* Barre de progression */}
          <div className="w-full h-1.5 rounded-full mb-2 cursor-default">
            <div className="w-full h-full bg-gray-300 rounded-full flex items-center justify-center">
              <span className="text-white text-xs">--:--</span>
            </div>
          </div>

          {/* Contrôles */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              {/* Icônes de contrôle désactivées */}
              <button className="text-gray-300 cursor-not-allowed transition-colors p-1.5" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </button>
              <button className="text-gray-300 cursor-not-allowed transition-colors p-1.5" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                </svg>
              </button>
              <button className="text-gray-300 cursor-not-allowed transition-colors p-1.5" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </button>
              <button className="text-gray-300 cursor-not-allowed transition-colors p-1.5" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
              <button className="text-gray-300 cursor-not-allowed transition-colors p-1.5" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15.536a5 5 0 001.414-1.414m-2.828 2.828a9 9 0 010-12.728" />
                </svg>
              </button>
              <button className="text-gray-300 cursor-not-allowed transition-colors p-1.5" disabled>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </button>

              {/* Affichage du temps */}
              <div className="text-xs text-gray-500 mx-2">
                --:--
              </div>
            </div>

            {/* Texte du canal */}
            <div className="font-medium text-gray-700 text-sm mx-1.5 truncate flex-1 text-center">
              {title}
            </div>

            {/* Icône de plein écran */}
            <button className="text-gray-400 cursor-not-allowed transition-colors p-1.5" disabled>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 0h-4m4 0l-5-5" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CameraPlaceholder;